var map = {
	"./font_anzu.png": "Bqpq",
	"./font_banana.png": "6D5P",
	"./font_beautiful.png": "Pjz/",
	"./font_darts.png": "lbbI",
	"./font_genshin.png": "rU2z",
	"./font_hui.png": "IMpw",
	"./font_kacho.png": "GjrF",
	"./font_malecharacter.png": "1MFH",
	"./font_uzura.png": "TRHO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "udt9";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child ^\.\/font_.*\.png$
// module id = udt9
// module chunks = 0